import { Reveal } from "@/components/Reveal";
import { LegalNotice } from "@/components/LegalNotice";
import { DATENSCHUTZ } from "@/data/site";

export default function Datenschutz() {
  return (
    <div data-testid="datenschutz-page" className="pt-32 pb-24 md:pb-32">
      <div className="mx-auto max-w-[820px] px-5 md:px-10">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Rechtliches</span>
          <h1 className="font-serif font-light text-5xl md:text-7xl tracking-tighter mt-5">Datenschutz&shy;erklärung</h1>
        </Reveal>

        <Reveal delay={0.05}><LegalNotice /></Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 divide-y divide-border border-t border-border">
            {DATENSCHUTZ.map((s) => (
              <div key={s.title} className="py-6">
                <h3 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-3">{s.title}</h3>
                <p className="text-foreground/80 leading-relaxed whitespace-pre-line">{s.body}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
